document.addEventListener('click', function (e) {
  const toggle = e.target.closest('.collection-description-toggle');
  if (!toggle) return;

  const box = toggle.closest('.collection-info-box');
  const full = box.querySelector('.collection-description-full');
  const short = box.querySelector('.collection-description-short');

  const expanded = toggle.getAttribute('aria-expanded') === 'true';

  toggle.setAttribute('aria-expanded', String(!expanded));
  toggle.textContent = expanded ? 'Les mer' : 'Vis mindre';

  box.classList.toggle('is-expanded', !expanded);

  full.hidden = expanded;
  short.hidden = !expanded;
});